import { render, staticRenderFns } from "./PrecificacaoClienteFinal.vue?vue&type=template&id=1c673063"
import script from "./PrecificacaoClienteFinal.vue?vue&type=script&lang=js"
export * from "./PrecificacaoClienteFinal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports